import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect,useSelector } from "react-redux";
import { addPost } from "../../actions/post";

const PostForm = ({ addPost, courseID }) => {
  const [text, setText] = useState("");
 const {user} = useSelector(state => state.auth)
  return (
    <div className="post-form">
      <form
        className="form my-1"
        onSubmit={(e) => {
          e.preventDefault();
          addPost({ text, courseID ,Rolls:user.rolls });
          setText("");
        }}
      >
        <textarea
          name="text"
          cols="30"
          rows="3"
          placeholder="اكتب السؤال او التعليق هنا ..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          required
        />
        <input type="submit" className="btn btn-dark my-1" value="إرسال" />
      </form>
    </div>
  );
};

PostForm.propTypes = {
  addPost: PropTypes.func.isRequired,
};

export default connect(null, { addPost })(PostForm);
